<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 style="text-transform: uppercase" v-if="options && options.label">
        ADD NEW {{ options.label || "N/A" }}
      </h4>
      <h4
        style="text-transform: uppercase"
        v-else-if="dataToShow && dataToShow.type"
      >
        Viewing {{ dataToShow.type }}
      </h4>

      <feather-icon
        icon="XIcon"
        @click.stop="close"
        class="cursor-pointer"
      ></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new pt-4 pb-6"
      :settings="settings"
    >
      <div class="p-6" v-if="isSidebarActiveLocal && options && options.fields">
        <div
          class="activeStatus mt-6 flex items-center justify-start"
          v-if="options.promoTypeEnable"
        >
          <label for="activeToggleN" class="flex items-center cursor-pointer">
            <div class="relative">
              <input
                id="activeToggleN"
                type="checkbox"
                class="sr-only"
                v-model="addObj.active"
              />
              <div
                class="w-10 h-6 bg-gray-400 rounded-full shadow-inner"
                style="background: #b5b5b5"
              ></div>
              <div
                class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"
              ></div>
            </div>
            <!-- label -->
            <div class="ml-3 text-gray-700 font-medium">
              {{ addObj.active ? "Active " : "Inactive " }} Promo
            </div>
          </label>
        </div>
        <template v-for="(field, fieldI) in options.fields">
          <vs-input
            v-if="field.type !== 'textarea'"
            :type="field.type"
            :label="field.label"
            :name="field.field"
            :oninput="field.oninput"
            v-model="addObj[field.field]"
            class="mt-5 w-full"
            :key="`vs-input${fieldI}${field.label}`"
          />
        </template>
        <div
          class="promoType mt-6"
          v-if="options.promoTypeEnable"
          style="display: flex; flex-direction: column"
        >
          <span
            style="
              color: rgba(0, 0, 0, 0.7);
              font-size: 0.85rem;
              padding-left: 5px;
            "
            class=""
            >Percentage / Dollar</span
          >
          <select
            style="
              border-radius: 5px;
              border: 1px solid rgba(0, 0, 0, 0.2);
              padding: 0.7rem;
              font-size: 1rem;
            "
            placeholder="Select Type"
            v-model="addObj.type"
          >
            <option value="percentage">Percentage (%)</option>
            <option value="dollar">Dollar ($)</option>
          </select>
        </div>

        <div
          class="textAreaSec mt-6"
          v-if="options.fields.find((x) => x.type == 'textarea')"
        >
          <span
            style="
              color: rgba(0, 0, 0, 0.7);
              font-size: 0.85rem;
              padding-left: 5px;
            "
            class=""
            >Description</span
          >
          <textarea rows="5" cols="42" v-model="addObj.description"></textarea>
        </div>

        <div class="roleColumn mt-6" v-if="options.selectClientRole">
          <span
            style="
              color: rgba(0, 0, 0, 0.7);
              font-size: 0.85rem;
              padding-left: 5px;
            "
            class=""
            >Role</span
          >
          <select
            style="
              border-radius: 5px;
              border: 1px solid rgba(0, 0, 0, 0.2);
              padding: 0.7rem;
              font-size: 1rem;
            "
            placeholder="Select Role"
            v-model="addObj.role"
          >
            <option label="Manage Truck/Driver & Purchase Tickets" value="1">
              Manage Truck/Driver & Purchase Tickets
            </option>
            <option label="Manage Truck/Driver" value="2">
              Manage Truck/Driver
            </option>


            <!-- <option value="3">
              Manage Truck
            </option>
            <option value="4">
              Manage Driver
            </option> -->


          </select>
        </div>
        <div class="roleColumn mt-6" v-if="options.selectAdmin">
          <span
            style="
              color: rgba(0, 0, 0, 0.7);
              font-size: 0.85rem;
              padding-left: 5px;
            "
            class=""
            >Role</span
          >
          <select
            style="
              border-radius: 5px;
              border: 1px solid rgba(0, 0, 0, 0.2);
              padding: 0.7rem;
              font-size: 1rem;
            "
            placeholder="Select Role"
            v-model="addObj.role"
          >
            <option label="Admin" value="1">Admin</option>
          </select>
        </div>

        <span class="text-sm text-danger block mt-5" v-if="showErrors">
          There are errors in your input. <br />Please review and tryagain
        </span>

        <!-- <vs-select v-model="category" label="Category" class="mt-5 w-full">
				<vs-select-item :key="data.value" :value="data.value" :text="data.text" v-for="data in category_choices" />
				</vs-select> -->

        <!-- <vs-select v-model="order_status" label="Order Status" class="mt-5 w-full">
				<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />
				</vs-select> -->

        <!-- <vs-input label="Price" name="price" v-model="price" class="mt-5 w-full" /> -->

        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->
      </div>

      <div
        v-else-if="
          isSidebarActiveLocal &&
          dataToShow &&
          dataToShow.type === 'transaction'
        "
        class="p-6"
      >
        <div class="mt-5">
          <h6>Time</h6>
          <p>{{ getTime(data.timestamp) }}</p>
        </div>

        <div class="mt-5">
          <h6>Action</h6>
          <p>{{ data.action || "N/A" }}</p>
        </div>

        <div class="mt-5" v-if="data.account && data.account.id">
          <h6>Related Client</h6>
          <p>
            <a href="#" @click.prevent="goTo(`/account/${data.account.id}`)">{{
              data.account.name
            }}</a>
          </p>
        </div>

        <div class="mt-5" v-if="data.product && data.product.id">
          <h6>Related Product</h6>
          <p>
            <a href="#" @click.prevent="goTo(`/product/${data.product.id}`)">{{
              data.product.name
            }}</a>
          </p>
        </div>

        <div class="mt-5" v-if="data.driver && data.driver.id">
          <h6>Related Driver</h6>
          <p>{{ data.driver.firstName }} {{ data.driver.lastName }}</p>
        </div>

        <div class="mt-5" v-if="data.truck && data.truck.id">
          <h6>Related Truck</h6>
          <p>
            {{ data.truck.licPlate }}
          </p>
        </div>

        <div class="mt-5" v-if="data.locations && data.locations.length">
          <h6>Pickup Locations</h6>
          <p
            v-for="(loc, locI) in data.locations"
            :key="`pickup${loc.date}${loc.id}`"
            :class="locI === 0 ? '' : 'mt-0'"
          >
            <strong>{{ loc.date }}</strong>
            {{ loc.location }}<br />
          </p>
        </div>

        <hr class="mt-5" />

        <div class="mt-8" v-if="data.user && data.user.id">
          <h6>Transaction by</h6>
          <p>
            {{ data.user.email }}
            {{ data.user.name }}<br />
          </p>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div
      class="flex flex-wrap items-center justify-center p-6"
      slot="footer"
      v-if="options && options.fields"
    >
      <vs-button class="mr-6" @click.native="addData">{{
        options.okText ? options.okText : "Submit"
      }}</vs-button>
      <vs-button type="border" color="danger" @click="close">{{
        options.cancelText ? options.cancelText : "Cancel"
      }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { validateEmail, setProp } from "@/assets/helper";

export default {
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },

    data: {
      type: Object,
    },
    options: {
      type: Object,
    },
  },

  watch: {
    isSidebarActiveLocal(val) {
      if (val) {
        if (!this.options.fields) return;
        if (!this.options.fields.length) return;

        this.options.fields.forEach((field) => {
          let value = field.type === "number" ? 0 : "";
          if (field.type == "number" && field.hasOwnProperty("min"))
            value = field.min;
          if (field.hasOwnProperty("default")) value = field.default;
          return setProp(this, ["addObj", field.field], value);
        });
      }
    },
    $route() {
      this.addObj = {};
      this.$emit("closeSidebar");
    },
  },
  data() {
    return {
      showErrors: false,
      addObj: {},
      name: "",
      category: "audio",
      order_status: "pending",
      price: "",

      category_choices: [
        { text: "Audio", value: "audio" },
        { text: "Computers", value: "computers" },
        { text: "Fitness", value: "fitness" },
        { text: "Appliance", value: "appliance" },
      ],
      order_status_choices: [
        { text: "Pending", value: "pending" },
        { text: "Canceled", value: "canceled" },
        { text: "Delivered", value: "delivered" },
        { text: "On Hold", value: "on_hold" },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    success() {
      let data = this.addObj;
      let result = JSON.parse(JSON.stringify(data));

      if (Object.keys(data).length === 0) return false;
      this.options.fields.forEach((field, fieldI) => {
        let key = field.field;
        let value = result[key];

        if (!result) return;
        console.log({ key, value, required: field.required, result });
        if (!field.required) {
          if (!result.hasOwnProperty(key)) {
            result[key] =
              field.type === "number" ? (field.min ? field.min : 0) : "";
          }
        }
        if (!result.hasOwnProperty(key) && field.required)
          return console.log("wrong"), (result = false);
        if (field.required && typeof value === "string" && !value.trim())
          return console.log("wrong"), (result = false);
        if (field.type === "email" && !this.validateEmail(value))
          return console.log("wrong"), (result = false);

        if (field.type === "number") {
          if (typeof parseFloat(value) !== "number")
            return console.log("wrong"), (result = false);
          result[key] = parseFloat(value);
        }
      });

      return result;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.addObj = {};
          this.$emit("closeSidebar");
        }
      },
    },
    dataToShow() {
      let obj = { type: "" };
      let data = this.data;
      if (data && data.timestamp) obj.type = "transaction";
      obj.data = data;
      return obj;
    },
  },
  methods: {
    errorIt(text = "Unforseen error Occurred") {
      return this.$vs.notify({
        title: "Error!",
        text,
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center",
      });
    },
    close() {
      this.isSidebarActiveLocal = false;
    },
    validateEmail,
    doCustom() {
      function ReverseString(str) {
        // Check input
        if (!str || str.length < 2 || typeof str !== "string") {
          return "Not valid";
        }

        // Take empty array revArray
        const revArray = [];
        const length = str.length - 1;

        // Looping from the end
        for (let i = length; i >= 0; i--) {
          revArray.push(str[i]);
        }

        // Joining the array elements
        return revArray.join("");
      }

      let add = this.options;
      let data = this.addObj;
      if (api === "accounts") {
        let { email } = data;
        delete data.email;
        this.$api
          .post("/accounts", data)
          .then(async (x) => {
            let accountID = (x.data && x.data.id) || false;
            console.log("ACCCOUNTTTIDDDDDDD", accountID);
            if (accountID) {
              let pss = ReverseString(email.split("@")[0]);
              try {
                let result = await this.$api.post("/auth/local/register", {
                  email,
                  username: email,
                  provider: "local",
                  confirmed: false,
                  password: `${accountID}${pss}`,
                  blocked: false,
                  role: "1",
                  name: data.name,
                  account: accountID,
                });
                if (result.data.jwt) {
                  this.close();
                  this.$vs.notify({
                    title: "Success",
                    text: "Account added successfully",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-check",
                    position: "bottom-center",
                  });
                } else this.errorIt();
              } catch (e) {
                this.errorIt();
              }
            } else {
              this.errorIt();
            }
          })
          .catch((e) => {
            this.errorIt();
          });
      }
    },
    addData() {
      this.showErrors = false;
      if (!this.success) return (this.showErrors = true);

      if (this.options.ok && typeof this.options.ok === "function")
        return this.this.options.ok(this.success);
      return this.$emit("ok", this.success);
    },
    goTo(x) {
      this.isSidebarActiveLocal = false;
      this.$router.push({ path: x });
    },
    getTime(time) {
      let date = new Date(time).toString().split(" ");
      return `${date[1]}/${date[2]}/${date[3]} - ${date[4]}`;
    },
    async save() {
      let apiRoute = this.$route.meta.apiRoute;
      if (!apiRoute) return console.error("no APi route");
      let needsSave = false;
      let keys = Object.keys(this.origItem);
      let result = "";
      keys.forEach((key) => {
        if (typeof this.item[key] !== "object") {
          console.log("COMPARING", this.item[key], "TO =>", this.origItem[key]);
          if (this.item[key] != this.origItem[key]) needsSave = true;
        }
      });
      if (needsSave) {
        result = await this.$store.dispatch("postData", {
          method: "put",
          route: apiRoute + "/" + this.item.id,
          data: this.item,
        });
        console.log("RESULTTTTTT", result);
      }
    },
  },
  components: {
    VuePerfectScrollbar,
  },
};
</script>

<style lang="scss" scoped>
.roleColumn {
  display: flex;
  flex-direction: column;
}
.textAreaSec {
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
  }
}
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
.activeStatus {
  .dot {
    top: 0;
    right: 50%;
  }
  input:checked ~ .dot {
    transform: translateX(100%) !important;
    background-color: #598d7f !important;
  }
}
</style>
